var _path, _path2, _path3, _path4, _path5, _path6, _path7;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23892 0.533188L2.09258 2.09757L0.732478 5.50714L7.23059 9.70151L11.0636 2.87764L8.23892 0.533188Z",
    fill: "#0DA05A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23059 9.70151L0.732478 5.50714L2.09258 2.09757L3.92341 1.63158L3.87103 4.7083L7.23059 9.70151Z",
    fill: "#CAEBDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95255 4.79729L3.83262 1.65396L2.08941 2.09765L0.758885 5.61015L3.95255 4.79729Z",
    fill: "#1FCF7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99746 3.76799L6.60005 0.949808L8.30334 0.516281L10.924 2.79641L7.99746 3.76799Z",
    fill: "#1FCF7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.87219 4.70758L3.92456 1.63086L6.54003 0.965163L8.05693 3.64246L7.23174 9.70078L3.87219 4.70758Z",
    fill: "#76F3B7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85819 4.82158L3.73825 1.67825L6.5061 0.973768L8.11642 3.73776L3.85819 4.82158Z",
    fill: "#0DA05A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16557 4.31333C4.54999 4.43179 3.95311 4.03484 3.82431 3.42134C3.89204 3.73155 3.83098 4.05595 3.65511 4.32031C3.47924 4.58467 3.20363 4.76634 2.89135 4.82374C3.50048 4.70137 4.1611 5.09678 4.28393 5.70584C4.15082 5.04599 4.5565 4.43616 5.16557 4.31333Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.5fe06c949a8b82a9ed8190b20dcc0a67.svg";
export { ForwardRef as ReactComponent };